export enum ProductRouteType {
  ABS = 'abs',
  CORPORATE = 'corporate',
  OTHER = 'other',
}
